// Identifica a pessoa sem mandar um $set a cada página. Quando o id já é o mesmo, o posthog-js
// transforma o identify com propriedades em setPersonProperties, e só lembra do que já mandou até
// a página recarregar; no PMS toda navegação recarrega. Aqui fica guardado no navegador um resumo
// (id + propriedades, sem o e-mail legível) do último envio, e as propriedades só vão de novo
// quando ele muda. Sem acesso ao localStorage (cota cheia, modo privado), manda sempre, como antes.
//
// Chega pelo page_context.js antes do init (posthog_init.js), como o posthog_before_send.js. Por
// isso é ES5 puro e não depende de nada.
(function (window) {
  var KEY = "hospedin:posthog:person";

  // djb2 de 32 bits: só precisa notar mudança, não esconder de quem tem o navegador.
  function fingerprint(distinctId, properties) {
    var text = JSON.stringify([distinctId, properties]);
    var hash = 5381;
    for (var i = 0; i < text.length; i++) {
      hash = ((hash << 5) + hash + text.charCodeAt(i)) | 0;
    }
    return (hash >>> 0).toString(36);
  }

  function read() {
    try {
      return window.localStorage.getItem(KEY);
    } catch (_error) {
      return null;
    }
  }

  function write(value) {
    try {
      window.localStorage.setItem(KEY, value);
    } catch (_error) {
      // Sem marca, a próxima página manda as propriedades de novo.
    }
  }

  function forget() {
    try {
      window.localStorage.removeItem(KEY);
    } catch (_error) {
      // Marca de outra pessoa não vale para o id novo: o fingerprint leva o id.
    }
  }

  // Sempre chama identify(id): é ele que troca o anônimo pelo identificado.
  window.posthogIdentify = function (client, distinctId, properties) {
    if (!properties) return client.identify(distinctId);

    var current = fingerprint(distinctId, properties);
    if (read() === current) return client.identify(distinctId);

    client.identify(distinctId, properties);
    // O posthog-js recusa o identify em alguns casos (id inválido, outro já identificado); aí
    // nada saiu e a marca ficaria mentindo.
    if (client.get_distinct_id() === distinctId) write(current);
  };

  window.posthogReset = function (client) {
    forget();
    client.reset();
  };
})(window);
